import React, { Component } from 'react';
import { selectors, actions } from './sagas/customers'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import { BottomRow } from './shared/BottomRow'
import IndexHeaders from './Customers/IndexHeaders'
import CustomerTable from './Customers/CustomerTable'
import NoCustomers from './Customers/NoCustomers'
import { ScrollSync } from 'react-scroll-sync'
import './stylesheets/customers.sass'

class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false
    };
    this.props.getCustomers();
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  render () {
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className='customers'>
          <div className='customers-title'>
            Customers
          </div>
          { this.props.customers &&
            this.props.customers.length > 0 &&
            <div>
              <ScrollSync>
                <div>
                  <IndexHeaders />
                  <CustomerTable />
                </div>
              </ScrollSync>
              <BottomRow
                widthClass={'bottom-row-5'}
              />
            </div>
          }
        </div>
      </div>
    );
  }

};

const mapStateToProps = (store) => ({
  customers: selectors.customers(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(mapStateToProps, mapDispatchToProps)(Customers))



// WEBPACK FOOTER //
// ./src/Customers.jsx